export default __webpack_public_path__ + "8306b24aa9468679378a3cc7fd20d408.png";